module.exports = __webpack_public_path__ + "static/media/6.0c1e7d1b.png";